import React from 'react';
import PropTypes from 'prop-types';
import { OverflowMenu } from '../../../components';
import hamburger from '../../../images/Homepage/DiscoverV3/hamburger.svg';

const NavigationMenu = () => (
  <OverflowMenu
    options={[
      {
        label: 'Volo Kids',
        onClick: () => {
          window.open('http://volokids.org/', '_blank');
        },
      },
      {
        label: 'Corporate',
        to: '/corporate',
      },
      {
        label: 'Contact Us',
        to: '/contact-us',
      },
    ]}
    position="bottomLeft"
    buttonType="gear"
    largeDots
    menuStyle={{ minWidth: '140px', textAlign: 'right' }}
    CustomButton={
      <div
        style={{
          height: '36px',
          width: '36px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        <img src={hamburger} alt="profile pic" width="14px" />
      </div>
    }
  />
);

NavigationMenu.propTypes = {
  currentUser: PropTypes.shape({
    picture: PropTypes.string,
  }),
};

NavigationMenu.defaultProps = {
  currentUser: undefined,
};

export default NavigationMenu;
